import { configureStore } from "@reduxjs/toolkit";
// Importa tus slices aquí
import strapiSlice from "./strapi/strapiSlice";
import { strapiApi } from "../api/strapiApi";
import { setupListeners } from "@reduxjs/toolkit/query/react";

export const store = configureStore({
  reducer: {
    strapi: strapiSlice,
    [strapiApi.reducerPath]: strapiApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(strapiApi.middleware),
});

setupListeners(store.dispatch);
